import { axiosConnectorInstance, axiosInfrakitIAMInstance } from "../App";

export const logIn = (data: FormData) => {
  const username = data.get("username");
  const password = data.get("password");

  return axiosInfrakitIAMInstance.post(
    `/auth/token?grant_type=password&username=${username}&password=${password}`
  );
};

export const getInfrakitProjects = () => {
  return axiosConnectorInstance
    .get(`/infrakit/projects`)
    .then((res) => res.data);
};

export const getConnections = (projectUuid: string) => {
  return axiosConnectorInstance
    .get(`/connections`, {
      params: {
        projectUuid,
      },
    })
    .then((res) => res.data);
};

export const createNewConnection = (projectUuid: string, name: string) => {
  return axiosConnectorInstance.post(
    `/connection?projectUuid=${projectUuid}&name=${name}`
  );
};

export const deleteConnectionByUuid = (connectionUuid: string) => {
  return axiosConnectorInstance.delete(`/connection/${connectionUuid}`);
};
